import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { Home } from '@/components/Home';

const homeSearchSchema = z.object({
  tasks: z.boolean().optional(),
  note: z.string().optional(),
});

export const Route = createFileRoute('/_auth/home')({
  validateSearch: homeSearchSchema,
  component: HomeRoute,
});

function HomeRoute() {

  return (
    <Home />
  );
}
